import * as types from "../constants/ActionTypes";


export function fetchAvailabilities(state = {availabilities: [], loading: false}, action) {
  switch (action.type) {
    case types.FETCH_AVAILABILITIES_SUCCESS:
      return {
        ...state,
        availabilities: action.payload.availabilities,
        serviceDuration: action.payload.serviceDuration
      };
    default:
      return state
  }
}

export function fetchAvailabilitiesDms(state = {availabilities: [], loading: false}, action) {
  switch (action.type) {
    case types.FETCH_AVAILABILITIES_DMS_SUCCESS:
      return {
        ...state,
        availabilities: action.payload.availabilities
      };
    default:
      return state
  }
}
